import { render, staticRenderFns } from "./RaterRateePage.vue?vue&type=template&id=2452e92c&"
import script from "./RaterRateePage.vue?vue&type=script&lang=ts&"
export * from "./RaterRateePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports